<template>
  <PrincipalPage/>
</template>

<script>
import PrincipalPage from './components/PrincipalPage.vue'

export default {
  name: 'App',
  components: {
    PrincipalPage
  },
}
</script>

<style>
@font-face {
  font-family: 'Amiri';
  src: url('@/assets/fonts/Amiri/Amiri-Regular.ttf') format('truetype'),
      url('@/assets/fonts/Amiri/Amiri-Bold.ttf') format('truetype'),
      url('@/assets/fonts/Amiri/Amiri-Italic.ttf') format('truetype'),
      url('@/assets/fonts/Amiri/Amiri-BoldItalic.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face{
  font-family: 'Amiri_Bold';
  src: url('@/assets/fonts/Amiri/Amiri-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style:normal;
}
@font-face {
  font-family: 'Abhaya Libre';
  src: url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Regular.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Bold.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Medium.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-SemiBold.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-ExtraBold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Abhaya Libre_Bold';
  src: url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}
.left-align{
  text-align: left;
  padding-left: 3vw;
}
.right-align{
  text-align: right;
  padding-right: 3vw;
}
@media(min-width: 922px){
  body{
    font-family: Amiri;
    font-weight: bold;
    background-color: #ffefbc;
    width: 100vw;
    height: 100vh;
    overflow-x:hidden;
  }
  #app {
    width: 98vw;
    height: 100vh;
    margin-left:0.5vw;
    margin-right:0.5vw;
    background-color: #ffefbc;
  }
  .last{
      margin-left: auto;
  }
}
@media(max-width: 922px) {
  body{
    font-family: Abhaya Libre;
    font-weight: bold;
    background-color: #ffefbc;
    margin: 0;
  }
  #app {
    width: 100vw;
    height: 100vh;
    background-color: #ffefbc;
  }
}
</style>
